import { supabase } from '../supabase/config';
import { normalizeProductImageSource } from '../utils';

const normalizeDatabaseProduct = (product) => {
  const image = normalizeProductImageSource(product.image_url || product.image || '');
  const storedImages = Array.isArray(product.images) && product.images.length ? product.images : [image];
  const images = storedImages.map(normalizeProductImageSource);
  if (!images[1]) images[1] = images[0] || image;
  return {
    ...product,
    image,
    images,
    label: product.category || 'CAB STORE',
    badge: 'Official CAB',
    sizes: Array.isArray(product.sizes) && product.sizes.length ? product.sizes : ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['#f5c400', '#111111', '#f5f5f5'],
  };
};

export const getStoreProducts = async () => {
  const { data, error } = await supabase.from('products').select('*')
    .order('sort_order', { ascending: true }).order('created_at', { ascending: false });
  if (error) throw error;
  return (data || []).map(normalizeDatabaseProduct);
};

export const getProductAvailability = async (productId) => {
  const { data, error } = await supabase
    .from('products')
    .select('in_stock')
    .eq('id', productId)
    .maybeSingle();
  if (error) throw error;
  return data?.in_stock;
};
